import { standardRequestWithErrorFlash } from '../../../shared/utils/request';
import type {
  ActivityFeedItem,
  Note,
} from 'candidate_profile_redesign/shared/types';
import type { Dispatch, State } from '../use_candidate_profile';

interface ActivityPayload {
  sort: string;
  search?: string;
  filters?: Array<string>;
  cursor?: number | null | undefined;
}

interface ActivityResponse {
  has_more: boolean;
  activity_feed: Array<ActivityFeedItem>;
}

type GetActivityItemsAction = {
  type: 'setActivityItems';
  payload: ActivityResponse;
};

type AddActivityItemsAction = {
  type: 'addActivityItems';
  payload: ActivityResponse;
};

export const getActivityItems =
  (state: State, dispatch: Dispatch) =>
  async (appendItems: boolean | null | undefined = false) => {
    const {
      paths: { activityFeedPath },
      activityFeed: { filters, activityItems },
    } = state;

    const params: ActivityPayload = {
      search: filters.search.trim(),
      sort: filters.sort.value,
      filters: filters.types.map((typeOption) => typeOption.value),
    };

    if (appendItems && activityItems) {
      params.cursor = activityItems[activityItems.length - 1].id;
    }

    try {
      dispatch({
        type: 'setStatus',
        payload: { key: 'activity_feed', type: 'loading' },
      });

      const { data } = await standardRequestWithErrorFlash.get(
        activityFeedPath,
        {
          params,
        }
      );

      if (appendItems) {
        dispatch({ type: 'addActivityItems', payload: data });
      } else {
        dispatch({ type: 'setActivityItems', payload: data });
      }
      dispatch({
        type: 'setStatus',
        payload: { key: 'activity_feed', type: 'complete' },
      });
    } catch (e: any) {
      dispatch({
        type: 'setStatus',
        payload: { key: 'activity_feed', type: 'error', context: e },
      });
    }
  };

type RemoveActivityItemAction = {
  type: 'removeActivityItem';
  payload: { itemId: number };
};

export const removeActivityItem =
  (state: State, dispatch: Dispatch) => (itemId: number) => {
    dispatch({ type: 'removeActivityItem', payload: { itemId } });
  };

type SetActivityFilterAction = {
  type: 'setActivityFilters';
  payload: object;
};

export const setActivityFilter =
  (state: State, dispatch: Dispatch) => (newFilterValue: any) => {
    dispatch({ type: 'setActivityFilters', payload: newFilterValue });
  };

export type Actions =
  | GetActivityItemsAction
  | AddActivityItemsAction
  | RemoveActivityItemAction
  | SetActivityFilterAction;
